import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface NewsletterArticle {
  id: string;
  title: string;
  url: string | null;
  published_date: string | null;
  source: string | null;
  source_feed: string | null;
  summary: string | null;
  short_summary: string | null;
  executive_briefing: string | null;
  opportunity_analysis: string | null;
  outreach_guidance: string | null;
  relevance_score: number | null;
  priority_level: number | null;
  signal_type: string | null;
  topics: string[] | null;
  matched_accounts: string[] | null;
  companies_mentioned: string[] | null;
  prospect_company_name: string | null;
  company_id: string | null;
  image_url: string | null;
}

export interface NewsletterPreview {
  intro_html: string;
  articles: NewsletterArticle[];
  html: string;
  generated_at: string;
  lookback_days?: number;
  max_articles?: number;
  warning?: string;
}

export interface NewsletterRequestBody {
  lookback_days?: number;
  max_articles?: number;
  regenerate_intro?: boolean;
}

export function useGenerateNewsletter() {
  return useMutation({
    mutationFn: async (body: NewsletterRequestBody = {}): Promise<NewsletterPreview> => {
      const { data, error } = await supabase.functions.invoke("generate-carr-newsletter", {
        body,
      });
      if (error) throw error;
      return data as NewsletterPreview;
    },
  });
}
